const showModal = ( modalName, modalProps={} ) => ( {
    type: 'SHOW_MODAL',
    modalName,
    modalProps,
} );

const switchModal = ( modalName, modalProps={} ) => ( {
    type: 'SWITCH_MODAL',
    modalName,
    modalProps,
} );

const hideModal = ( modalName ) => ( {
    type: 'HIDE_MODAL',
    modalName,
} );

export {
    showModal,
    switchModal,
    hideModal,
};
